<template>
    <td>{{ isSteadyState ? $t('dosages.form.steadyState') : $dateFormat.humanDateTime(dosageTimeRange.start) }}</td>
    <td>{{ isSteadyState ? $t('dosages.form.steadyState') : $dateFormat.humanDateTime(dosageTimeRange.end) }}</td>

    <generic-dosage-choice-row :dosage-choice="dosageChoice" />

    <td class="text-right buttons-container">
        <slot name="tools" />
    </td>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue';
import { DosageTimeRange } from '@/service/models/request/computation/dosage-time-range';
import { DosageSteadyState } from '@/service/models/common/query-dosage/parts/dosage-steady-state';
import GenericDosageChoiceRow from '../common/dosage-choices-rows/GenericDosageChoiceRow.vue';

export default defineComponent({
    components: {
        GenericDosageChoiceRow
    },

    props: {
        dosageTimeRange: {
            type: Object as PropType<DosageTimeRange>,
            required: true,
        },
    },

    setup(props)
    {
        const dosageChoice = computed(() => props.dosageTimeRange.dosage.getInnerDosageChoice());
        const isSteadyState = computed(() => props.dosageTimeRange.dosage.dosageRepeat instanceof DosageSteadyState);

        return {
            dosageChoice,
            isSteadyState,
        };
    },
})
</script>

